const state = {
  employees: [],
  selectedEmployee: null,
  employeeFetchParams: {
    ordersYear: null,
    ordersMonth: null,
  },
  selectedEmployeeMessages: [],
  selectedEmployeeOrders: [],
  selectedEmployeeAbsences: [],
  employeeAvailability: [],
  selectedEmployeeSumOfPayments: 0,
  employeesPrimaryInfo: [],
  employeesInMonth: [],
  selectedEmployeeReportsOrders: [],
  selectedEmployeeAttachments: [],
  employeeScheduledHours: {},
  employeeBills: [],
};
const mutations = {
  SET_DOD_EMPLOYEES(state, employees) {
    state.employees = employees;
  },
  SET_DOD_SELECTED_EMPLOYEE(state, employee) {
    state.selectedEmployee = employee;
  },
  SET_DOD_SELECTED_EMPLOYEE_PAYMENT(state, payment) {
    state.selectedEmployeeSumOfPayments = payment;
  },
  SET_EMPLOYEE_FETCH_PARAMS(state, params) {
    for (let [key, value] of Object.entries(params)) {
      state.employeeFetchParams[key] = value;
    }
  },
  SET_DOD_SELECTED_EMPLOYEE_MESSAGES(state, messages) {
    state.selectedEmployeeMessages = messages;
  },
  SET_DOD_SELECTED_EMPLOYEE_ORDERS(state, orders) {
    state.selectedEmployeeOrders = orders;
  },
  SET_DOD_SELECTED_EMPLOYEE_ABSENCES(state, absences) {
    state.selectedEmployeeAbsences = absences;
  },
  SET_DOD_SELECTED_EMPLOYEE_AVAILABILITY(state, employeeAvailability) {
    state.employeeAvailability = employeeAvailability;
  },
  SET_DOD_EMPLOYEES_PRIMARY_INFO(state, employees) {
    state.employeesPrimaryInfo = employees;
  },
  SET_DOD_EMPLOYEES_IN_MONTH(state, employees) {
    state.employeesInMonth = employees;
  },
  SET_DOD_SELECTED_EMPLOYEE_REPORTS_ORDERS(state, orders) {
    state.selectedEmployeeReportsOrders = orders;
  },
  SET_DOD_SELECTED_EMPLOYEE_ATTACHMENTS(state, attachments) {
    state.selectedEmployeeAttachments = attachments;
  },
  SET_DOD_EMPLOYEE_SCHEDULED_HOURS(state, scheduledHoursWithMax) {
    state.employeeScheduledHours = scheduledHoursWithMax;
  },
  SET_DOD_EMPLOYEE_BILLS(state, bills) {
    state.employeeBills = bills;
  },
};
const getters = {
  getDodEmployees: (state) => state.employees,
  getDodSelectedEmployee: (state) => state.selectedEmployee,
  getDodEmployeeFetchParams: (state) => state.employeeFetchParams,
  getDodSelectedEmployeeMessages: (state) => state.selectedEmployeeMessages,
  getDodSelectedEmployeeOrders: (state) => state.selectedEmployeeOrders,
  getDodSelectedEmployeeAbsences: (state) => state.selectedEmployeeAbsences,
  getDodSelectedEmployeeAvailability: (state) => state.employeeAvailability,
  getDodSelectedEmployeeSumOfPayment: (state) =>
    state.selectedEmployeeSumOfPayments,
  getDodEmployeesPrimaryInfo: (state) => state.employeesPrimaryInfo,
  getDodEmployeesInMonth: (state) => state.employeesInMonth,
  getDodSelectedEmployeeReportsOrders: (state) =>
    state.selectedEmployeeReportsOrders,
  getDodSelectedEmployeeAttachments: (state) =>
    state.selectedEmployeeAttachments,
  getDodEmployeeScheduledHours: (state) => state.employeeScheduledHours,
  getDodEmployeeBills: (state) => state.employeeBills,
};

export default {
  state,
  mutations,
  getters,
};
